import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'

export const B2BOrderIcon = LocalShippingOutlinedIcon
export default B2BOrderIcon
